import React from 'react';
import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';

const LANGUAGES = [
    { code: 'en', name: 'English' },
    { code: 'es', name: 'Español' },
    { code: 'fr', name: 'Français' },
    { code: 'de', name: 'Deutsch' },
    { code: 'ja', name: '日本語' },
    { code: 'zh-CN', name: '简体中文' },
    { code: 'hi', name: 'हिन्दी' },
    { code: 'ar', name: 'العربية' },
    { code: 'pt', name: 'Português' },
    { code: 'ru', name: 'Русский' },
    { code: 'ko', name: '한국어' },
    { code: 'it', name: 'Italiano' },
    { code: 'nl', name: 'Nederlands' },
    { code: 'sv', name: 'Svenska' },
    { code: 'pl', name: 'Polski' },
    { code: 'tr', name: 'Türkçe' },
    { code: 'vi', name: 'Tiếng Việt' },
    { code: 'th', name: 'ไทย' },
    { code: 'id', name: 'Bahasa Indonesia' },
    { code: 'ms', name: 'Bahasa Melayu' },
    { code: 'fil', name: 'Filipino' },
    { code: 'el', name: 'Ελληνικά' },
    { code: 'he', name: 'עברית' },
    { code: 'hu', name: 'Magyar' },
    { code: 'cs', name: 'Čeština' },
    { code: 'da', name: 'Dansk' },
    { code: 'fi', name: 'Suomi' },
    { code: 'no', name: 'Norsk' },
    { code: 'ro', name: 'Română' },
    { code: 'uk', name: 'Українська' }
];

const LanguageView = () => {
    const { t, i18n } = useTranslation();

    const handleLanguageChange = (langCode) => {
        i18n.changeLanguage(langCode);
    };

    return (
        <div className="bg-black/20 backdrop-blur-md rounded-2xl p-6 border border-slate-700/50">
            <h2 className="text-3xl font-bold font-playfair mb-2 text-cyan-300">{t('settings.languageRegion.title')}</h2>
            <p className="mb-6 text-gray-400">{t('settings.languageRegion.description')}</p>

            <div className="relative">
                <select
                    value={i18n.language}
                    onChange={(e) => handleLanguageChange(e.target.value)}
                    className="w-full p-4 rounded-lg bg-slate-800/50 border border-slate-700/50 appearance-none focus:outline-none focus:ring-2 focus:ring-cyan-500"
                    aria-label={t('settings.languageRegion.displayLanguage')}
                >
                    {LANGUAGES.map((lang) => (
                        <option key={lang.code} value={lang.code}>
                            {lang.name}
                        </option>
                    ))}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-400">
                    <Check size={20} />
                </div>
            </div>
        </div>
    );
};

export default LanguageView;
